import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  MODULES_OUTCOME,
  MODULES_OUTCOME_CREATE,
  MODULES_OUTCOME_LIST,
  MODULES_OUTCOME_RECALCULATE,
} from '../constants/actionTypes'
import {
  MODULES_OUTCOME as API_MODULES_OUTCOME,
  MODULES_OUTCOME_LIST as API_MODULES_OUTCOME_LIST,
  MODULES_OUTCOME_RECALCULATE as API_MODULES_OUTCOME_RECALCULATE,
} from '../constants/api'

export const modulesOutcome = createAsyncThunk(
  MODULES_OUTCOME,
  async (params: PayloadCreatorParams<`${typeof API_MODULES_OUTCOME}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.modulesOutcome(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const modulesOutcomeCreate = createAsyncThunk(
  MODULES_OUTCOME_CREATE,
  async (params: PayloadCreatorParams<`${typeof API_MODULES_OUTCOME_LIST}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.modulesOutcomeCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const modulesOutcomeList = createAsyncThunk(
  MODULES_OUTCOME_LIST,
  async (params: PayloadCreatorParams<`${typeof API_MODULES_OUTCOME_LIST}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.modulesOutcomeList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const modulesOutcomeRecalculate = createAsyncThunk(
  MODULES_OUTCOME_RECALCULATE,
  async (params: PayloadCreatorParams<`${typeof API_MODULES_OUTCOME_RECALCULATE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.modulesOutcomeRecalculate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const modulesOutcomeListClear = createAction(`${MODULES_OUTCOME_LIST}/clear`)

export const modulesOutcomeClear = createAction(`${MODULES_OUTCOME}/clear`)
